// Discount tiers applied to FastGrip kits.
// Keep these values in sync with GripKitPage's progress bars.
export const FASTGRIP_DISCOUNT_TIERS = [
  { threshold: 100, rate: 0.05, label: '5%' },
  { threshold: 250, rate: 0.10, label: '10%' },
  { threshold: 500, rate: 0.15, label: '15%' },
];

/**
 * Compute kit subtotal, applied discount and final daily price from a list of kit items.
 *
 * @param {Array<{daily_price:number, quantity:number}>} items
 * @returns {{subtotal:number, activeTier:object|null, discountAmount:number, total:number}}
 */
export function computeKitPricing(items) {
  const subtotal = (items || []).reduce(
    (sum, i) => sum + (i.daily_price || 0) * (i.quantity || 0),
    0
  );
  const activeTier =
    [...FASTGRIP_DISCOUNT_TIERS]
      .reverse()
      .find(t => subtotal >= t.threshold) || null;
  const discountAmount = activeTier ? subtotal * activeTier.rate : 0;
  const total = subtotal - discountAmount;
  return { subtotal, activeTier, discountAmount, total };
}
